const url = "wss://127.0.0.1:1337";

export default url;
